import React, { useState } from 'react';
import { Modal } from '../../components/ui';
import { errMsg } from '../../utils/format';
import { useFetch } from '../../hooks/useFetch';
import api from '../../utils/api';

export default function EditRawMaterialModal({ material, onClose, onSaved }) {
  const { data: vendors } = useFetch('/api/vendors');
  const { data: categories } = useFetch('/api/raw-materials/categories');
  const [form, setForm] = useState({
    name: material.name || '',
    unitOfMeasure: material.unit_of_measure || '',
    category: material.category || '',
    quantityOnHand: material.quantity_on_hand || 0,
    unitCost: material.unit_cost || 0,
    minStockLevel: material.min_stock_level || 0,
    criticalStockLevel: material.critical_stock_level || 0,
    preferredVendorId: material.preferred_vendor_id || '',
    notes: material.notes || '',
  });
  const [saving, setSaving] = useState(false);
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const save = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await api.patch(`/api/raw-materials/${material.id}`, {
        ...form,
        preferredVendorId: form.preferredVendorId || null,
      });
      onSaved('Material updated successfully');
      onClose();
    } catch (err) {
      alert(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal title={`Edit — ${material.name}`} onClose={onClose}
      footer={
        <div style={{ display:'flex', justifyContent:'space-between', width:'100%' }}>
          <button className="btn btn-danger btn-sm" onClick={async () => {
            if (!window.confirm(`Delete "${material.name}"? This cannot be undone.`)) return;
            try {
              await api.delete(`/api/raw-materials/${material.id}`);
              onSaved('Material deleted');
              onClose();
            } catch (err) { alert(errMsg(err)); }
          }}><i className="ti ti-trash" /> Delete</button>
          <div style={{ display:'flex', gap:8 }}>
            <button className="btn" onClick={onClose}>Cancel</button>
            <button className="btn btn-primary" form="edit-mat-form" type="submit">
              {saving ? 'Saving…' : 'Save'}
            </button>
          </div>
        </div>
      }>
      <form id="edit-mat-form" onSubmit={save}>
        <div className="form-row">
          <div className="form-group">
            <label>Material name *</label>
            <input required value={form.name} onChange={e => set('name', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Unit of measure *</label>
            <input required value={form.unitOfMeasure} onChange={e => set('unitOfMeasure', e.target.value)} placeholder="e.g. kg, m, units" />
          </div>
        </div>
        <div className="form-group">
          <label>Category</label>
          <input list="rm-categories-edit" value={form.category} onChange={e => set('category', e.target.value)} placeholder="e.g. Hardware, Electronics, Mounts" />
          <datalist id="rm-categories-edit">
            {(categories || []).map(c => <option key={c} value={c} />)}
          </datalist>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Quantity on hand</label>
            <input type="number" step="0.0001" min="0" value={form.quantityOnHand}
              onChange={e => set('quantityOnHand', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Unit cost ($)</label>
            <input type="number" step="0.0001" min="0" value={form.unitCost}
              onChange={e => set('unitCost', e.target.value)} />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label>Minimum stock level</label>
            <input type="number" step="0.0001" min="0" value={form.minStockLevel}
              onChange={e => set('minStockLevel', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Critical stock level</label>
            <input type="number" step="0.0001" min="0" value={form.criticalStockLevel}
              onChange={e => set('criticalStockLevel', e.target.value)} />
          </div>
        </div>
        <div className="form-group">
          <label>Preferred vendor</label>
          <select value={form.preferredVendorId} onChange={e => set('preferredVendorId', e.target.value)}>
            <option value="">— None —</option>
            {(vendors || []).map(v => <option key={v.id} value={v.id}>{v.name}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Notes</label>
          <textarea value={form.notes} onChange={e => set('notes', e.target.value)} />
        </div>
      </form>
    </Modal>
  );
}
